import paydayAssets from '../scenes/SalesPages/PayDay/payDayImages';
import holiFestivalDealsAssets from '../scenes/SalesPages/HoliFestivalDeals/HoliFestivalDealsImages';

export const OFFERS_PAGE_DATA = {
  heroBanner: {
    imageUrl: holiFestivalDealsAssets?.heroBanner,
    eventName: '',
  },
  close: {
    imageUrl: paydayAssets?.close,
  },
  rewards: [
    {
      imageUrl: holiFestivalDealsAssets?.rewards?.reliance,
      redirectUrl: 'https://twidpay.com/app',
      eventName: 'AppWebpageBannerClicked',
      type: 'Rewards Waiting at Every Store',
      position: 1,
      name: 'Reliance Fresh',
      inApp: true,
    },
    {
      imageUrl: holiFestivalDealsAssets?.rewards?.cobb,
      redirectUrl: 'https://twidpay.com/app',
      eventName: 'AppWebpageBannerClicked',
      type: 'Rewards Waiting at Every Store',
      position: 2,
      name: 'Cobb',
      inApp: true,
    },
    {
      imageUrl: holiFestivalDealsAssets?.rewards?.barista,
      redirectUrl: 'https://twidpay.com/app',
      eventName: 'AppWebpageBannerClicked',
      type: 'Rewards Waiting at Every Store',
      position: 3,
      name: 'Barista',
      inApp: true,
    },
    {
      imageUrl: holiFestivalDealsAssets?.rewards?.wow,
      redirectUrl: 'https://twidpay.com/app',
      eventName: 'AppWebpageBannerClicked',
      type: 'Rewards Waiting at Every Store',
      position: 4,
      name: 'Wow Momos',
      inApp: true,
    },
    {
      imageUrl: holiFestivalDealsAssets?.rewards?.mcd,
      redirectUrl: 'https://twidpay.com/app',
      eventName: 'AppWebpageBannerClicked',
      type: 'Rewards Waiting at Every Store',
      position: 5,
      name: 'Mc Donalds',
      inApp: true,
    },
    {
      imageUrl: holiFestivalDealsAssets?.rewards?.pizzahut,
      redirectUrl: 'https://twidpay.com/app',
      eventName: 'AppWebpageBannerClicked',
      type: 'Rewards Waiting at Every Store',
      position: 6,
      name: 'Pizza Hut',
      inApp: true,
    },
    {
      imageUrl: holiFestivalDealsAssets?.rewards?.bikernerwala,
      redirectUrl: 'https://twidpay.com/app',
      eventName: 'AppWebpageBannerClicked',
      type: 'Rewards Waiting at Every Store',
      position: 7,
      name: 'Bikernervala',
      inApp: true,
    },
    {
      imageUrl: holiFestivalDealsAssets?.rewards?.archies,
      redirectUrl: 'https://twidpay.com/app',
      eventName: 'AppWebpageBannerClicked',
      type: 'Rewards Waiting at Every Store',
      position: 8,
      name: 'Archies',
      inApp: true,
    },
    {
      imageUrl: holiFestivalDealsAssets?.rewards?.manCompany,
      redirectUrl: 'https://twidpay.com/app',
      eventName: 'AppWebpageBannerClicked',
      type: 'Rewards Waiting at Every Store',
      position: 9,
      name: 'Tha Man Company',
      inApp: true,
    },
  ],
  verifiedBy: [
    {
      logoUrl: paydayAssets?.secure?.verified,
    },
    {
      logoUrl: paydayAssets?.secure?.secure,
    },
    {
      logoUrl: paydayAssets?.secure?.reserve,
    },
  ],
  // redirection link
  app: [
    {
      logoUrl: paydayAssets?.app?.earn,
      redirectUrl: 'https://twidpay.com/app',
      eventName: 'AppWebpageBannerClicked',
      type: 'App Exclusive',
      position: 1,
      name: 'TWID Stars',
      inApp: true,
    },
    {
      logoUrl: paydayAssets?.app?.reward,
      redirectUrl: 'https://twidpay.com/app',
      eventName: 'AppWebpageBannerClicked',
      type: 'App Exclusive',
      position: 2,
      name: 'Scan and Pay',
      inApp: true,
    },
    {
      logoUrl: paydayAssets?.app?.ixigo,
      redirectUrl: 'https://f.ixigo.com/Zb6T-gGZFAw6',
      eventName: 'AppWebpageBannerClicked',
      type: 'App Exclusive',
      position: 3,
      name: 'Ixigo',
      inApp: false,
    },
  ],
  holiFestivalDealsCategories: [
    {
      imageUrl: holiFestivalDealsAssets?.categories?.food,
      eventName: 'AppWebpageBannerClicked',
      type: 'Season of Savings - Up to 50% OFF',
      position: 1,
      name: 'Food & Groceries',
    },
    {
      imageUrl: holiFestivalDealsAssets?.categories?.travel,
      eventName: 'AppWebpageBannerClicked',
      type: 'Season of Savings - Up to 50% OFF',
      position: 2,
      name: 'Travel',
    },
    {
      imageUrl: holiFestivalDealsAssets?.categories?.shopping,
      eventName: 'AppWebpageBannerClicked',
      type: 'Season of Savings - Up to 50% OFF',
      position: 3,
      name: 'Shopping',
    },
    {
      imageUrl: holiFestivalDealsAssets?.categories?.electronics,
      eventName: 'AppWebpageBannerClicked',
      type: 'Season of Savings - Up to 50% OFF',
      position: 4,
      name: 'Electronics',
    },
    {
      imageUrl: holiFestivalDealsAssets?.categories?.entertainment,
      eventName: 'AppWebpageBannerClicked',
      type: 'Season of Savings - Up to 50% OFF',
      position: 5,
      name: 'Entertainment',
    },
  ],
  holiFestivalDealsBrandsInSpotlight: [
    {
      imageUrl:
        holiFestivalDealsAssets?.holiFestivalDealsSpotlightBrands
          ?.spotlight_brand_1,
      redirectUrl: 'https://www.swiggy.com//',
      eventName: 'AppWebpageBannerClicked',
      type: 'Brands in Spotlight',
      position: 1,
      name: 'Swiggy',
      inApp: false,
    },
    {
      imageUrl:
        holiFestivalDealsAssets?.holiFestivalDealsSpotlightBrands
          ?.spotlight_brand_2,
      redirectUrl: 'https://jiomart.onelink.me/Qg0u/twidpay%5C',
      eventName: 'AppWebpageBannerClicked',
      type: 'Brands in Spotlight',
      position: 2,
      name: 'JioMart',
      inApp: false,
    },
    {
      imageUrl:
        holiFestivalDealsAssets?.holiFestivalDealsSpotlightBrands
          ?.spotlight_brand_3,
      redirectUrl: 'https://www.swiggy.com/instamart',
      eventName: 'AppWebpageBannerClicked',
      type: 'Brands in Spotlight',
      position: 3,
      name: 'Instamart',
      inApp: false,
    },
    {
      imageUrl:
        holiFestivalDealsAssets?.holiFestivalDealsSpotlightBrands
          ?.spotlight_brand_4,
      redirectUrl: 'https://www.abhibus.com/',
      eventName: 'AppWebpageBannerClicked',
      type: 'Brands in Spotlight',
      position: 4,
      name: 'AbhiBus',
      inApp: false,
    },
    {
      imageUrl:
        holiFestivalDealsAssets?.holiFestivalDealsSpotlightBrands
          ?.spotlight_brand_5,
      redirectUrl: 'https://www.eatsure.com/',
      eventName: 'AppWebpageBannerClicked',
      type: 'Brands in Spotlight',
      position: 5,
      name: 'EatSure',
      inApp: false,
    },
    {
      imageUrl:
        holiFestivalDealsAssets?.holiFestivalDealsSpotlightBrands
          ?.spotlight_brand_6,
      redirectUrl: 'https://www.redbus.in/',
      eventName: 'AppWebpageBannerClicked',
      type: 'Brands in Spotlight',
      position: 6,
      name: 'Redbus',
      inApp: false,
    },
    {
      imageUrl:
        holiFestivalDealsAssets?.holiFestivalDealsSpotlightBrands
          ?.spotlight_brand_7,
      redirectUrl: 'https://www.easemytrip.com/',
      eventName: 'AppWebpageBannerClicked',
      type: 'Brands in Spotlight',
      position: 7,
      name: 'EaseMyTrip',
      inApp: false,
    },
    {
      imageUrl:
        holiFestivalDealsAssets?.holiFestivalDealsSpotlightBrands
          ?.spotlight_brand_8,
      redirectUrl: 'https://www.themancompany.com/',
      eventName: 'AppWebpageBannerClicked',
      type: 'Brands in Spotlight',
      position: 8,
      name: 'The Man Company',
      inApp: false,
    },
  ],
  otherBrands: [
    {
      logoUrl: holiFestivalDealsAssets?.otherBrands?.ConfirmTkt,
      redirectUrl: '/offers/confirmtkt',
      eventName: 'AppWebpageBannerClicked',
      type: 'OTHER BRANDS',
      position: 1,
      name: 'ConfirmTkt',
    },
    {
      logoUrl: holiFestivalDealsAssets?.otherBrands?.BookMyShow,
      redirectUrl: '/offers/bookmyshow',
      eventName: 'AppWebpageBannerClicked',
      type: 'OTHER BRANDS',
      position: 1,
      name: 'BookMyShow',
    },
    {
      logoUrl: holiFestivalDealsAssets?.otherBrands?.Zeeraki,
      redirectUrl: '/offers/zeeraki',
      eventName: 'AppWebpageBannerClicked',
      type: 'OTHER BRANDS',
      position: 1,
      name: 'Zeeraki Jewels',
    },
    {
      logoUrl: holiFestivalDealsAssets?.otherBrands?.Netmeds,
      redirectUrl: '/offers/netmeds',
      eventName: 'AppWebpageBannerClicked',
      type: 'OTHER BRANDS',
      position: 1,
      name: 'Netmeds',
    },
    {
      logoUrl: holiFestivalDealsAssets?.otherBrands?.JustHerbs,
      redirectUrl: '/offers/justherbs',
      eventName: 'AppWebpageBannerClicked',
      type: 'OTHER BRANDS',
      position: 1,
      name: 'JustHerbs',
    },
  ],
  appExclusive: [
    {
      logoUrl: holiFestivalDealsAssets?.appExclusive?.TwidStars,
      redirectUrl: 'https://twidpay.com/app',
      eventName: 'AppWebpageBannerClicked',
      type: 'App Exclusive',
      position: 1,
      name: 'TWID Stars',
      inApp: true,
    },
    {
      logoUrl: holiFestivalDealsAssets?.appExclusive?.TwidScanAndPay,
      redirectUrl: 'https://twidpay.com/app',
      eventName: 'AppWebpageBannerClicked',
      type: 'App Exclusive',
      position: 2,
      name: 'Scan and Pay',
      inApp: true,
    },
    {
      logoUrl: holiFestivalDealsAssets?.appExclusive?.Ixigo,
      redirectUrl: 'https://f.ixigo.com/Zb6T-gGZFAw6',
      eventName: 'AppWebpageBannerClicked',
      type: 'App Exclusive',
      position: 3,
      name: 'Ixigo',
      inApp: false,
    },
  ],
};
